/** KCC (Client Center) system_access code */
export const KCC_SYSTEM_ACCESS = 'kcc';

export interface AccessTraits {
  role?: string;
  system_access?: string[] | string;
  [key: string]: unknown;
}

export function normalizeSystemAccess(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((v): v is string => typeof v === 'string');
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter((v): v is string => typeof v === 'string');
      }
    } catch {
      // ignore
    }
    return value ? [value] : [];
  }
  return [];
}

export function hasSystemAccess(
  traits: AccessTraits | null | undefined,
  required: string
): boolean {
  if (!traits) return false;
  if (traits.role === 'super_admin') return true;
  return normalizeSystemAccess(traits.system_access).includes(required);
}

export function hasKccAccess(traits: AccessTraits | null | undefined): boolean {
  return hasSystemAccess(traits, KCC_SYSTEM_ACCESS);
}
